import Swal from "sweetalert2";
import { change_Payment_status, PayBalanceApi, payment_status_api, process_payment_api } from "services/invice";
import qr_code_img from "assets/images/qr-code.png";
import card_img from "assets/images/debit-card.png";
import upicard_img from "assets/images/upicard.png";

export const PAYMENT_BUTTON_STYLES = {
  upi: {
    background: "linear-gradient(135deg, #059669 0%, #10b981 100%)",
    shadow: "0 4px 14px rgba(5, 150, 105, 0.35)",
  },
  card: {
    background: "linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)",
    shadow: "0 4px 14px rgba(37, 99, 235, 0.35)",
  },
  all: {
    background: "linear-gradient(135deg, #7c3aed 0%, #a855f7 100%)",
    shadow: "0 4px 14px rgba(124, 58, 237, 0.35)",
  },
};

export const PAYMENT_SESSION_KEY = "pos_online_payment_session";
export const PAYMENT_CASH_EVENT = "pos-payment-cash";
export const CASH_MODAL_FROM_PAYMENT_INITIATED_KEY =
  "pos_cash_modal_from_payment_initiated";

export function markCashModalFromPaymentInitiated() {
  sessionStorage.setItem(CASH_MODAL_FROM_PAYMENT_INITIATED_KEY, "1");
}

export function isCashModalFromPaymentInitiated() {
  return sessionStorage.getItem(CASH_MODAL_FROM_PAYMENT_INITIATED_KEY) === "1";
}

export function clearCashModalFromPaymentInitiated() {
  sessionStorage.removeItem(CASH_MODAL_FROM_PAYMENT_INITIATED_KEY);
}

export const BALANCE_CASH_GATEWAY_CONTEXT_KEY =
  "pos_balance_cash_gateway_context";

export function buildCapturedGatewayContext(session, fromState) {
  const gatewayTransactionId =
    session?.gatewayTransactionId || fromState?.gatewayTransactionId;

  if (!gatewayTransactionId) {
    return null;
  }

  const fgatewayTransactionId =
    session?.fgatewayTransactionId || fromState?.fgatewayTransactionId;
  const gateway =
    session?.paymentRequest?.gateway || fromState?.paymentRequest?.gateway;

  const context = {
    gateway_transaction_id: String(gatewayTransactionId),
    ...(session?.pgId || fromState?.pgId
      ? { pgId: session?.pgId || fromState?.pgId }
      : {}),
    ...(gateway?.pg_brand ? { pg_brand: gateway.pg_brand } : {}),
  };

  if (fgatewayTransactionId != null && fgatewayTransactionId !== "") {
    context.fgateway_transaction_id = String(fgatewayTransactionId);
  }

  return context;
}

export function applyGatewayTxnFieldsToPayload(target, context) {
  if (!context) {
    return;
  }

  if (context.gateway_transaction_id) {
    target.gateway_transaction_id = context.gateway_transaction_id;
  }

  if (context.fgateway_transaction_id) {
    target.fgateway_transaction_id = context.fgateway_transaction_id;
  }

  if (context.pgId) {
    target.pgId = context.pgId;
  }

  if (context.pg_brand) {
    target.pg_brand = context.pg_brand;
  }
}

export function captureBalanceCashGatewayContext() {
  const context = buildCapturedGatewayContext(readPaymentSession(), null);
  if (!context) {
    return;
  }

  sessionStorage.setItem(
    BALANCE_CASH_GATEWAY_CONTEXT_KEY,
    JSON.stringify(context)
  );
}

export function readBalanceCashGatewayContext() {
  try {
    const raw = sessionStorage.getItem(BALANCE_CASH_GATEWAY_CONTEXT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
}

export function clearBalanceCashGatewayContext() {
  sessionStorage.removeItem(BALANCE_CASH_GATEWAY_CONTEXT_KEY);
}

export function normalizePaymentMode(mode) {
  return String(mode || "").trim().toUpperCase();
}

export function isOnlineRefundDisallowedForPaymentType(paymentType) {
  const normalized = normalizePaymentMode(paymentType);
  return normalized === "MP" || normalized === "C";
}

export function getSelectedGateway(userData) {
  return userData?.assigned_device?.[0] || null;
}

export function isRefundAllowedGateway(gateway) {
  return String(gateway?.refund_allowed || "").trim().toUpperCase() === "Y";
}

export function hasRefundAllowedGateway(gateways = []) {
  return gateways.some(isRefundAllowedGateway);
}

export function matchesBillPgId(gateway, billPgId) {
  if (billPgId == null || billPgId === "") {
    return true;
  }
  return String(gateway?.id) === String(billPgId);
}

export function getRefundGatewayForBill(gateways = [], billPgId) {
  if (billPgId == null || billPgId === "") {
    return null;
  }
  return gateways.find(
    (gateway) =>
      matchesBillPgId(gateway, billPgId) && isRefundAllowedGateway(gateway)
  );
}

export function canRefundViaBillPgGateway(gateways = [], billPgId) {
  return Boolean(getRefundGatewayForBill(gateways, billPgId));
}

export function getGatewaysForOnlinePayment(
  gateways = [],
  isRefundScenario = false,
  billPgId = null
) {
  if (!isRefundScenario) {
    return gateways;
  }

  return gateways.filter(
    (gateway) =>
      isRefundAllowedGateway(gateway) && matchesBillPgId(gateway, billPgId)
  );
}

export function canUseGatewayForOnlinePayment(
  gateway,
  isRefundScenario = false,
  billPgId = null
) {
  if (!gateway?.id) return false;
  if (isRefundScenario) {
    if (!isRefundAllowedGateway(gateway)) {
      return false;
    }
    if (!matchesBillPgId(gateway, billPgId)) {
      return false;
    }
  }
  return true;
}

export function getReturnInvoicenumFromCart(cartProducts = [], storeReturnInvoicenum) {
  if (storeReturnInvoicenum) {
    return storeReturnInvoicenum;
  }

  const returnProduct = cartProducts.find((product) => product?.selected_product);
  return (
    returnProduct?.return_invoicenum ||
    returnProduct?.invoiceNumber ||
    null
  );
}

export function getReturnPaymentFromInvoice(invoiceData) {
  const payments = invoiceData?.payment;
  if (!Array.isArray(payments) || payments.length === 0) {
    return null;
  }

  const paymentWithPgId = payments.find(
    (payment) => payment?.bill_pgId != null && payment?.bill_pgId !== ""
  );

  return paymentWithPgId ?? payments[0] ?? null;
}

export function getBillPgIdFromInvoice(invoiceData) {
  return getReturnPaymentFromInvoice(invoiceData)?.bill_pgId ?? null;
}

export function getRetTransactionIdFromInvoice(invoiceData) {
  return getReturnPaymentFromInvoice(invoiceData)?.transaction_id ?? null;
}

export function hasGatewaySelected(userData) {
  return Boolean(getSelectedGateway(userData)?.id);
}

export function shouldShowGatewayList(userData) {
  return !hasGatewaySelected(userData);
}

export function shouldAutoProcessPayment(gateway) {
  if (!gateway?.id) return false;
  return normalizePaymentMode(gateway?.payment_mode) !== "BOTH";
}

export function getGatewayLabel(gateway) {
  const brand = String(gateway?.pg_brand || "").toUpperCase();
  const deviceName = gateway?.pg_name || "";
  return `${brand} (${deviceName})`;
}

export function getPaymentButtonsForGateway(gateway) {
  const mode = normalizePaymentMode(gateway?.payment_mode);
  const buttons = [];

  if (mode === "BOTH") {
    buttons.push({
      key: "upi",
      label: "UPI",
      icon: qr_code_img,
      variant: "upi",
      allowedPaymentMode: gateway?.upi_paymentmode,
      payMode: "PTM",
    });
    buttons.push({
      key: "card",
      label: "CARD",
      icon: card_img,
      variant: "card",
      allowedPaymentMode: gateway?.card_paymentmode,
      payMode: "CC",
    });
    return buttons;
  }

  if (mode === "ALL") {
    buttons.push({
      key: "all",
      label: "UPI/CARD",
      icon: upicard_img,
      variant: "all",
      allowedPaymentMode: "ALL",
      payMode: "PTM",
    });
    return buttons;
  }

  if (mode === "UPI") {
    buttons.push({
      key: "upi",
      label: "UPI",
      icon: qr_code_img,
      variant: "upi",
      allowedPaymentMode: gateway?.upi_paymentmode || gateway?.payment_mode,
      payMode: "PTM",
    });
    return buttons;
  }

  if (mode === "CARD") {
    buttons.push({
      key: "card",
      label: "CARD",
      icon: card_img,
      variant: "card",
      allowedPaymentMode: gateway?.card_paymentmode || gateway?.payment_mode,
      payMode: "CC",
    });
    return buttons;
  }

  buttons.push({
    key: "default",
    label: "Pay",
    icon: qr_code_img,
    variant: "upi",
    allowedPaymentMode: gateway?.payment_mode,
    payMode: "PTM",
  });
  return buttons;
}

export function mapPayModeForInvoice(allowedPaymentMode, gateway) {
  const allowed = String(allowedPaymentMode || "");
  const cardMode = String(gateway?.card_paymentmode || "");
  if (
    allowed === cardMode ||
    normalizePaymentMode(allowed) === "CARD" ||
    allowed === "1"
  ) {
    return "CC";
  }
  return "PTM";
}

export function buildGstBreakup(taxValue) {
  const breakUpGst = Math.abs(parseFloat(taxValue || 0).toFixed(2)) / 2;
  return `CGST:${breakUpGst}|SGST:${breakUpGst}`;
}

export function extractGatewayTransactionId(message) {
  if (!message) return null;
  if (typeof message === "object") {
    return (
      message.gateway_transaction_id ||
      message.transaction_id ||
      message.TransactionId ||
      message.PlutusTransactionReferenceID ||
      null
    );
  }

  const str = String(message).trim();
  if (!str) return null;

  try {
    const parsed = JSON.parse(str);
    return (
      parsed.gateway_transaction_id ||
      parsed.transaction_id ||
      parsed.TransactionId ||
      parsed.PlutusTransactionReferenceID ||
      null
    );
  } catch (error) {
    const patterns = [
      /gateway_transaction_id["'\s:=]+([A-Za-z0-9_-]+)/i,
      /transaction_id["'\s:=]+([A-Za-z0-9_-]+)/i,
      /PlutusTransactionReferenceID["'\s:=]+([A-Za-z0-9_-]+)/i,
    ];

    for (const pattern of patterns) {
      const match = str.match(pattern);
      if (match?.[1]) return match[1];
    }

    if (/^[A-Za-z0-9_-]+$/.test(str)) return str;
    return null;
  }
}

export function parseProcessPaymentResponse(rawBody = {}) {
  const layers = [
    rawBody,
    rawBody?.data,
    rawBody?.result,
    rawBody?.body,
    rawBody?.pos_udaan,
  ].filter(Boolean);

  let status = "";
  let message = "";
  let gatewayTransactionId = null;

  for (const layer of layers) {
    if (!status && layer?.status != null && layer?.status !== "") {
      status = normalizePaymentMode(layer.status);
    }
    if (!message && layer?.message != null && layer?.message !== "") {
      message = String(layer.message);
    }
    if (!gatewayTransactionId && layer?.gateway_transaction_id) {
      gatewayTransactionId = String(layer.gateway_transaction_id);
    }
  }

  if (!gatewayTransactionId) {
    gatewayTransactionId = extractGatewayTransactionId(message);
  }

  return { status, message, gatewayTransactionId };
}

export const SQR_PAYMENT_SHOW_EVENT = "pos-sqr-payment-show";
export const SQR_PAYMENT_COMPLETE_EVENT = "pos-sqr-payment-complete";
export const BALANCE_PAYMENT_CASH_EVENT = "pos-balance-payment-cash";
export const BALANCE_PAYMENT_ONLINE_EVENT = "pos-balance-payment-online";

let sqrPaymentCallbacks = null;
let pendingSqrPaymentDetail = null;

export function getPendingSqrPaymentDetail() {
  return pendingSqrPaymentDetail;
}

export function clearPendingSqrPaymentDetail() {
  pendingSqrPaymentDetail = null;
}

export function getSqrPaymentCallbacks() {
  return sqrPaymentCallbacks;
}

export function clearSqrPaymentCallbacks() {
  sqrPaymentCallbacks = null;
}

export function completeSqrPaymentFlow(detail = {}) {
  window.dispatchEvent(
    new CustomEvent(SQR_PAYMENT_COMPLETE_EVENT, { detail })
  );
  clearPendingSqrPaymentDetail();
  clearSqrPaymentCallbacks();
}

export function parseSqrPaymentResponse(rawBody = {}) {
  let source = rawBody;

  if (typeof source === "string") {
    try {
      source = JSON.parse(source);
    } catch (error) {
      source = {};
    }
  }

  const layers = [
    source,
    source?.data,
    source?.result,
    source?.body,
    source?.pos_udaan,
  ].filter(Boolean);

  let sqr_payment = "";
  let transactions = [];

  for (const layer of layers) {
    if (layer?.sqr_payment != null && layer?.sqr_payment !== "") {
      sqr_payment = String(layer.sqr_payment).trim().toUpperCase();
    }
    if (Array.isArray(layer?.transactions)) {
      transactions = layer.transactions;
    }
  }

  return {
    sqr_payment,
    transactions,
    isSqrPayment: sqr_payment === "Y",
  };
}

export function filterSqrTransactions(transactions = [], utrQuery = "", amountRs = "") {
  const list = Array.isArray(transactions) ? transactions : [];
  const utr4 = String(utrQuery || "").trim();
  const hasUtr = utr4.length > 0;
  const hasAmount =
    amountRs !== "" && amountRs != null && !Number.isNaN(parseFloat(amountRs));
  const amount = hasAmount ? parseFloat(amountRs) : null;

  if (!hasUtr && !hasAmount) {
    return list;
  }

  return list.filter((txn) => {
    const utr = String(txn?.utr || "");
    const txnAmountRs = Number(txn?.amount || 0) / 100;
    const utrMatch =
      !hasUtr || utr.slice(-4) === utr4 || utr.endsWith(utr4);
    const amountMatch =
      !hasAmount || Math.abs(txnAmountRs - amount) < 0.01;
    return utrMatch && amountMatch;
  });
}

export async function fetchSqrTransactions({ pgId, sqr_utrtxnid, amountRs }) {
  const payload = { pgId };

  if (sqr_utrtxnid) {
    payload.sqr_utrtxnid = String(sqr_utrtxnid);
  }

  const amountTrimmed = String(amountRs ?? "").trim();
  if (amountTrimmed !== "" && !Number.isNaN(parseFloat(amountTrimmed))) {
    payload.Amount = Math.round(parseFloat(amountTrimmed) * 100);
  }

  const response = await process_payment_api(payload);
  const body = response?.data?.body || {};
  const parsed = parseProcessPaymentResponse(body);
  const sqr = parseSqrPaymentResponse(body);

  return {
    response,
    body,
    status: parsed.status,
    message: parsed.message,
    transactions: sqr.transactions,
    isSqrPayment: sqr.isSqrPayment,
  };
}

export function showSqrPaymentTransactionsFlow({
  transactions,
  pgId,
  amountRs,
  paymentRequest,
  onSuccess,
  onCash,
  onOnline,
}) {
  sqrPaymentCallbacks = { onSuccess, onCash, onOnline };

  const detail = {
    mode: "transactions",
    transactions: Array.isArray(transactions) ? transactions : [],
    pgId,
    pg_brand: paymentRequest?.gateway?.pg_brand ?? null,
    amountRs,
    paymentRequest,
    balancePayment: paymentRequest?.balancePayment ?? "N",
    billOrderId: paymentRequest?.billOrderId ?? null,
    salesExecutiveId: paymentRequest?.salesExecutiveId ?? null,
    invoiceId:
      paymentRequest?.invoiceNumber ?? paymentRequest?.transactionNumber ?? null,
  };

  pendingSqrPaymentDetail = detail;

  return new Promise((resolve) => {
    const completeHandler = (event) => {
      window.removeEventListener(SQR_PAYMENT_COMPLETE_EVENT, completeHandler);
      clearPendingSqrPaymentDetail();
      resolve(event.detail || { action: "closed" });
    };

    window.addEventListener(SQR_PAYMENT_COMPLETE_EVENT, completeHandler);

    const dispatchShow = () => {
      window.dispatchEvent(
        new CustomEvent(SQR_PAYMENT_SHOW_EVENT, { detail })
      );
    };

    dispatchShow();
    setTimeout(dispatchShow, 0);
    setTimeout(dispatchShow, 250);
  });
}

export function isSqrEnabledGateway(gateway) {
  return String(gateway?.sqr_enabled || "").trim().toUpperCase() === "Y";
}

export async function initiateSqrGatewayPayment({
  pgId,
  amount,
  fgatewayTransactionId,
}) {
  const payload = { pgId };

  const amountTrimmed = String(amount ?? "").trim();
  if (amountTrimmed !== "" && !Number.isNaN(parseFloat(amountTrimmed))) {
    payload.Amount = Math.round(parseFloat(amountTrimmed) * 100);
  }

  if (fgatewayTransactionId != null && fgatewayTransactionId !== "") {
    payload.fgateway_transaction_id = String(fgatewayTransactionId);
  }

  const response = await process_payment_api(payload);
  const body = response?.data?.body || {};
  const parsed = parseProcessPaymentResponse(body);
  const sqr = parseSqrPaymentResponse(body);

  return {
    response,
    body,
    status: parsed.status,
    gatewayTransactionId: parsed.gatewayTransactionId,
    message: parsed.message,
    transactions: sqr.transactions,
    isSqrPayment: sqr.isSqrPayment,
  };
}

export async function processSqrBalancePayment({
  billOrderId,
  balancePaid,
  salesExecutiveId,
  pgId,
  pg_brand,
  utr,
}) {
  const pos_udaan = {
    bal_pay_mode: "QR",
    balance_paid: parseFloat(balancePaid),
    balance_payment: "Y",
    balance_payment_status: "S",
    bill_order_id: billOrderId,
    sales_executive_id: salesExecutiveId,
    other_txn_no: String(utr || ""),
  };

  if (pgId != null && pgId !== "") {
    pos_udaan.pgId = pgId;
  }

  if (pg_brand != null && pg_brand !== "") {
    pos_udaan.pg_brand = pg_brand;
  }

  const response = await PayBalanceApi(pos_udaan);
  const body = response?.data?.body || {};

  return {
    success: body?.status == 1 || body?.status === 1,
    response,
    body,
  };
}

export async function processSqrUpiTransaction({
  invoiceId,
  utr,
  tenderAmt,
  pgId,
  pg_brand,
}) {
  const pos_udaan = {
    inv_status: "S",
    invoiceId: parseInt(invoiceId, 10),
    other_txn_no: String(utr || ""),
    pay_mode: "QR",
    pay_note: "",
    tender_amt: parseFloat(tenderAmt).toFixed(2),
  };

  if (pgId != null && pgId !== "") {
    pos_udaan.pgId = pgId;
  }

  if (pg_brand != null && pg_brand !== "") {
    pos_udaan.pg_brand = pg_brand;
  }

  const response = await change_Payment_status({
    pos_udaan,
  });

  const body = response?.data?.body || {};

  return {
    success: body?.status == 1,
    response,
    body,
  };
}

export async function showSqrPaymentFailPopup({ onCash, onOnline }) {
  const result = await Swal.fire({
    text: "Transactions cannot be listed, try later.",
    icon: "warning",
    showConfirmButton: false,
    showDenyButton: Boolean(onOnline),
    denyButtonText: "Online",
    showCancelButton: Boolean(onCash || onOnline),
    cancelButtonText: "Cash",
    allowOutsideClick: false,
  });

  if (result.isDenied) {
    onOnline?.();
    return { action: "online" };
  }

  if (result.dismiss === Swal.DismissReason.cancel) {
    onCash?.();
    return { action: "cash" };
  }

  return { action: "dismissed" };
}

export function savePaymentSession(session) {
  localStorage.setItem(PAYMENT_SESSION_KEY, JSON.stringify(session));
}

/** Last successfully initiated txn id to send as fgateway_transaction_id on gateway switch. */
export function resolveFgatewayTransactionIdForSwitch(session) {
  if (!session) {
    return undefined;
  }

  const currentTxnId = session.gatewayTransactionId;
  if (currentTxnId != null && currentTxnId !== "") {
    return String(currentTxnId);
  }

  const storedFgatewayTxnId = session.fgatewayTransactionId;
  if (storedFgatewayTxnId != null && storedFgatewayTxnId !== "") {
    return String(storedFgatewayTxnId);
  }

  return undefined;
}

/** fgateway_transaction_id to persist after a switch attempt (success or failure). */
export function resolvePersistedFgatewayTransactionId(
  session,
  previousGatewayTransactionId
) {
  if (
    previousGatewayTransactionId != null &&
    previousGatewayTransactionId !== ""
  ) {
    return String(previousGatewayTransactionId);
  }

  const storedFgatewayTxnId = session?.fgatewayTransactionId;
  if (storedFgatewayTxnId != null && storedFgatewayTxnId !== "") {
    return String(storedFgatewayTxnId);
  }

  return undefined;
}

export function readPaymentSession() {
  try {
    const raw = localStorage.getItem(PAYMENT_SESSION_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch (error) {
    return null;
  }
}

export function clearPaymentSession() {
  localStorage.removeItem(PAYMENT_SESSION_KEY);
}

/** Clears all persisted/in-memory payment flow state between bills. */
export function clearAllPaymentFlowState() {
  clearPaymentSession();
  clearCashModalFromPaymentInitiated();
  clearBalanceCashGatewayContext();
  clearPendingSqrPaymentDetail();
  clearSqrPaymentCallbacks();
}

export async function initiateProcessPayment({
  gateway,
  amount,
  invoiceNumber,
  transactionNumber,
  gstBrkUp,
  gstIn,
  allowedPaymentMode,
  balancePayment,
  returnInvoicenum,
  retTransactionId,
  fgatewayTransactionId,
}) {
  const payload = {
    pgId: gateway?.id,
    Amount: Math.round(parseFloat(amount) * 100),
    GstBrkUp: gstBrkUp,
    GstIn: gstIn || "",
    Invoicenumber: invoiceNumber,
    TransactionNumber: transactionNumber,
    AllowedPaymentMode: allowedPaymentMode,
  };

  if (balancePayment === "Y") {
    payload.balance_payment = "Y";
  }

  if (returnInvoicenum) {
    payload.return_invoicenum = returnInvoicenum;
  }

  if (retTransactionId) {
    payload.ret_transactionId = retTransactionId;
  }

  if (fgatewayTransactionId != null && fgatewayTransactionId !== "") {
    payload.fgateway_transaction_id = String(fgatewayTransactionId);
  }

  const response = await process_payment_api(payload);
  const body = response?.data?.body || {};
  const parsed = parseProcessPaymentResponse(body);

  return {
    response,
    body,
    status: parsed.status,
    gatewayTransactionId: parsed.gatewayTransactionId,
    message: parsed.message,
  };
}

export function extractPaymentStatusResponse(rawBody = {}) {
  const layers = [
    rawBody,
    rawBody?.data,
    rawBody?.result,
    rawBody?.body,
    rawBody?.pos_udaan,
  ].filter(Boolean);

  let status = "";
  let message = "";

  for (const layer of layers) {
    if (layer?.status != null && layer?.status !== "") {
      status = normalizePaymentMode(layer.status);
    }
    if (layer?.message != null && layer?.message !== "") {
      message = String(layer.message);
    }
  }

  return { status, message, body: rawBody };
}

export function isFailPaymentStatus(status) {
  const normalized = normalizePaymentMode(status);
  return normalized === "FAIL" || normalized === "FAILED";
}

export function isPendingPaymentStatus(status) {
  return normalizePaymentMode(status) === "PENDING";
}

export function formatPaymentNotConfirmedMessage(result) {
  const parsed = extractPaymentStatusResponse(result?.body || {});
  const status = normalizePaymentMode(result?.status || parsed.status || "UNKNOWN");
  const message =
    result?.message ||
    parsed.message ||
    result?.body?.message ||
    "";

  if (status === "TIMEOUT") {
    return `TIMEOUT:${message || "Payment confirmation timed out."}`;
  }

  return `${status}:${message || "Payment not confirmed."}`;
}

export function formatPaymentFailMessage(status, message) {
  const normalizedStatus = normalizePaymentMode(status || "UNKNOWN");
  const detail = message || "Unable to initiate payment.";
  return `${normalizedStatus}:${detail}`;
}

export async function checkPaymentStatusOnce({
  pgId,
  gatewayTransactionId,
  balancePayment,
  refund,
}) {
  const payload = {
    pgId,
    gateway_transaction_id: gatewayTransactionId,
  };

  if (balancePayment === "Y") {
    payload.balance_payment = "Y";
  }

  if (refund === "Y") {
    payload.refund = "Y";
  }

  try {
    const response = await payment_status_api(payload);
    const body = response?.data?.body || {};
    const parsed = extractPaymentStatusResponse(body);
    const status = parsed.status || normalizePaymentMode(body?.status);

    if (status === "SUCCESS" || body?.status === 1) {
      return { status: "SUCCESS", body, response, message: parsed.message };
    }

    if (isFailPaymentStatus(status)) {
      return {
        status: "FAIL",
        body,
        response,
        message: parsed.message || body?.message || "",
      };
    }

    if (isPendingPaymentStatus(status)) {
      return {
        status: "PENDING",
        body,
        response,
        message: parsed.message || body?.message || "",
      };
    }

    return {
      status: status || "UNKNOWN",
      body,
      response,
      message: parsed.message || body?.message || "",
    };
  } catch (error) {
    return {
      status: "ERROR",
      message: "Unable to check payment status.",
    };
  }
}

export async function pollPaymentStatus({
  pgId,
  gatewayTransactionId,
  balancePayment,
  refund,
  intervalMs = 2000,
  timeoutMs = 60000,
  shouldAbort = () => false,
  onPendingUpdate,
}) {
  const startedAt = Date.now();
  let lastPendingMessage = "";

  while (Date.now() - startedAt < timeoutMs) {
    if (shouldAbort()) {
      return { status: "ABORTED" };
    }

    const result = await checkPaymentStatusOnce({
      pgId,
      gatewayTransactionId,
      balancePayment,
      refund,
    });

    if (result.status === "SUCCESS") {
      return result;
    }

    if (isFailPaymentStatus(result.status)) {
      return result;
    }

    if (isPendingPaymentStatus(result.status)) {
      lastPendingMessage = result.message || lastPendingMessage;
      onPendingUpdate?.({
        status: result.status,
        message: lastPendingMessage,
      });
    } else if (result.status && result.status !== "SUCCESS") {
      return result;
    }

    if (shouldAbort()) {
      return { status: "ABORTED" };
    }

    await new Promise((resolve) => setTimeout(resolve, intervalMs));
  }

  return {
    status: "TIMEOUT",
    message: lastPendingMessage || "Payment confirmation timed out.",
  };
}

export async function showPaymentFailPopup({
  status,
  message,
  onRetry,
  onCash,
  onClose,
  showOnlineButton,
  onOnline,
}) {
  const result = await Swal.fire({
    title: "PAYMENT NOT INITIATED",
    text: formatPaymentFailMessage(status, message),
    icon: "error",
    showConfirmButton: Boolean(onRetry),
    confirmButtonText: "Check Status",
    showDenyButton: Boolean(showOnlineButton),
    denyButtonText: "ONLINE",
    showCancelButton: Boolean(onCash || onClose),
    cancelButtonText: onCash ? "Cash" : "Close",
    showCloseButton: false,
    allowOutsideClick: false,
    allowEscapeKey: false,
  });

  if (result.isConfirmed) {
    return onRetry?.();
  }

  if (result.isDenied) {
    onOnline?.();
    return { action: "online" };
  }

  if (result.dismiss === Swal.DismissReason.cancel) {
    if (onCash) {
      markCashModalFromPaymentInitiated();
      onCash?.({ fromPaymentInitiated: true });
      return { action: "cash" };
    }
    onClose?.();
    return { action: "close" };
  }

  return { action: "dismissed" };
}

export async function showPaymentNotConfirmedPopup({
  message,
  pgId,
  gatewayTransactionId,
  balancePayment,
  refund,
  showOnlineButton,
  onSuccess,
  onCash,
  onOnline,
  onClose,
}) {
  const result = await Swal.fire({
    title: "PAYMENT NOT CONFIRMED",
    text: message || "UNKNOWN:Payment not confirmed.",
    icon: "warning",
    showConfirmButton: true,
    confirmButtonText: "Check Status",
    showDenyButton: Boolean(showOnlineButton),
    denyButtonText: "ONLINE",
    showCancelButton: Boolean(onCash || onClose),
    cancelButtonText: onCash ? "Cash" : "Close",
    allowOutsideClick: false,
  });

  if (result.isConfirmed) {
    const checkResult = await checkPaymentStatusOnce({
      pgId,
      gatewayTransactionId,
      balancePayment,
      refund,
    });

    if (checkResult.status === "SUCCESS") {
      onSuccess?.(checkResult);
      return checkResult;
    }

    if (isPendingPaymentStatus(checkResult.status)) {
      return showPaymentInitiatedPopup({
        pgId,
        gatewayTransactionId,
        balancePayment,
        refund,
        showOnlineButton,
        onSuccess,
        onCash,
        onOnline,
        onClose,
      });
    }

    return showPaymentNotConfirmedPopup({
      message: formatPaymentNotConfirmedMessage(checkResult),
      pgId,
      gatewayTransactionId,
      balancePayment,
      refund,
      showOnlineButton,
      onSuccess,
      onCash,
      onOnline,
      onClose,
    });
  }

  if (result.isDenied) {
    onOnline?.();
    return { action: "online" };
  }

  if (result.dismiss === Swal.DismissReason.cancel) {
    if (onCash) {
      onCash?.();
      return { action: "cash" };
    }
    onClose?.();
    return { action: "close" };
  }

  return { action: "dismissed" };
}

export async function showPaymentInitiatedPopup({
  pgId,
  gatewayTransactionId,
  balancePayment,
  refund,
  showOnlineButton,
  onSuccess,
  onCash,
  onOnline,
  onClose,
}) {
  let pollAborted = false;
  let finished = false;

  const statusParams = {
    pgId,
    gatewayTransactionId,
    balancePayment,
    refund,
  };

  const handleSuccess = (result) => {
    if (finished) return;
    finished = true;
    pollAborted = true;
    Swal.close();
    onSuccess?.(result);
  };

  const handleDismiss = () => {
    if (finished) return;
    finished = true;
    pollAborted = true;
    if (onCash) {
      markCashModalFromPaymentInitiated();
      onCash?.({ fromPaymentInitiated: true });
      return;
    }
    onClose?.();
  };

  const pollingPromise = new Promise((resolve) => {
    if (!pgId || !gatewayTransactionId) {
      resolve({
        status: "TIMEOUT",
        message: "Missing transaction reference.",
      });
      return;
    }

    pollPaymentStatus({
      pgId,
      gatewayTransactionId,
      balancePayment,
      refund,
      shouldAbort: () => pollAborted,
      onPendingUpdate: ({ message }) => {
        const pendingText = message
          ? formatPaymentNotConfirmedMessage({
              status: "PENDING",
              message,
            })
          : "Waiting for confirmation";
        Swal.update({ text: pendingText });
      },
    }).then(resolve);
  });

  const manualStatusCheck = async () => {
    Swal.showLoading();
    const checkResult = await checkPaymentStatusOnce(statusParams);
    Swal.hideLoading();

    if (checkResult.status === "SUCCESS") {
      handleSuccess(checkResult);
      return { handled: true, result: checkResult };
    }

    if (isPendingPaymentStatus(checkResult.status)) {
      Swal.update({
        text: formatPaymentNotConfirmedMessage({
          status: "PENDING",
          message: checkResult.message,
        }),
      });
      Swal.showLoading();
      return { handled: true, result: checkResult };
    }

    finished = true;
    pollAborted = true;
    Swal.close();

    await showPaymentNotConfirmedPopup({
      message: formatPaymentNotConfirmedMessage(checkResult),
      pgId,
      gatewayTransactionId,
      balancePayment,
      refund,
      showOnlineButton,
      onSuccess,
      onCash,
      onOnline,
      onClose,
    });

    return { handled: true, result: checkResult };
  };

  const swalPromise = Swal.fire({
    title: "PAYMENT INITIATED",
    text: "Waiting for confirmation",
    icon: "info",
    showConfirmButton: true,
    confirmButtonText: "Check Status",
    showCancelButton: Boolean(onClose || onCash),
    cancelButtonText: onCash ? "Cash" : "Close",
    allowOutsideClick: false,
    didOpen: () => {
      Swal.showLoading();
    },
    preConfirm: async () => {
      const { handled } = await manualStatusCheck();
      return handled ? false : undefined;
    },
    preCancel: () => {
      pollAborted = true;
    },
  });

  swalPromise.then((result) => {
    if (result.dismiss === Swal.DismissReason.cancel) {
      handleDismiss();
    }
  });

  const pollResult = await pollingPromise;

  if (finished) {
    if (pollResult.status === "SUCCESS") {
      return pollResult;
    }
    return { status: "ABORTED", action: onCash ? "cash" : "close" };
  }

  finished = true;
  Swal.close();

  if (pollResult.status === "SUCCESS") {
    onSuccess?.(pollResult);
    return pollResult;
  }

  if (pollResult.status === "ABORTED") {
    return pollResult;
  }

  return showPaymentNotConfirmedPopup({
    message: formatPaymentNotConfirmedMessage(pollResult),
    pgId,
    gatewayTransactionId,
    balancePayment,
    refund,
    showOnlineButton,
    onSuccess,
    onCash,
    onOnline,
    onClose,
  });
}

async function retryProcessPayment({
  paymentRequest,
  balancePayment,
  refund,
  showOnlineGatewayOption,
  onSuccess,
  onCash,
  onClose,
  onOnline,
}) {
  try {
    const session = readPaymentSession();
    const previousGatewayTransactionId = session?.gatewayTransactionId;
    const fgatewayTransactionId = resolveFgatewayTransactionIdForSwitch(session);

    const paymentResult = await initiateProcessPayment({
      gateway: paymentRequest.gateway,
      amount: paymentRequest.amount,
      invoiceNumber: paymentRequest.invoiceNumber,
      transactionNumber: paymentRequest.transactionNumber,
      gstBrkUp: paymentRequest.gstBrkUp,
      gstIn: paymentRequest.gstIn,
      allowedPaymentMode: paymentRequest.allowedPaymentMode,
      balancePayment: paymentRequest.balancePayment,
      returnInvoicenum: paymentRequest.returnInvoicenum,
      retTransactionId: paymentRequest.retTransactionId,
      fgatewayTransactionId,
    });
    const retryPgId = paymentRequest.gateway?.id;
    const persistedFgateway = resolvePersistedFgatewayTransactionId(
      session,
      previousGatewayTransactionId
    );

    savePaymentSession({
      pgId: retryPgId,
      gatewayTransactionId: paymentResult.gatewayTransactionId,
      balancePayment:
        paymentRequest.balancePayment === "Y" ? "Y" : balancePayment,
      refund:
        parseFloat(paymentRequest.amount) < 0 ? "Y" : refund || "N",
      invoiceId: paymentRequest.invoiceNumber,
      status: normalizePaymentMode(paymentResult.status),
      message: paymentResult.message,
      useNewPaymentFlow: true,
      paymentRequest,
      ...(persistedFgateway ? { fgatewayTransactionId: persistedFgateway } : {}),
    });

    return runOnlinePaymentUi({
      status: paymentResult.status,
      message: paymentResult.message,
      pgId: retryPgId,
      gatewayTransactionId: paymentResult.gatewayTransactionId,
      balancePayment:
        paymentRequest.balancePayment === "Y" ? "Y" : balancePayment,
      refund: parseFloat(paymentRequest.amount) < 0 ? "Y" : refund || "N",
      paymentRequest,
      processPaymentBody: paymentResult.body,
      showOnlineGatewayOption,
      onSuccess,
      onCash,
      onClose,
      onOnline,
    });
  } catch (error) {
    return showPaymentFailPopup({
      status: "ERROR",
      message: "Unable to initiate online payment.",
      onRetry: () =>
        retryProcessPayment({
          paymentRequest,
          balancePayment,
          refund,
          showOnlineGatewayOption,
          onSuccess,
          onCash,
          onClose,
          onOnline,
        }),
      onCash,
      onClose,
      showOnlineButton:
        refund !== "Y" && showOnlineGatewayOption && Boolean(onOnline),
      onOnline,
    });
  }
}

export async function runOnlinePaymentUi({
  status,
  message,
  pgId,
  gatewayTransactionId,
  balancePayment = "N",
  refund = "N",
  paymentRequest,
  processPaymentBody,
  showOnlineGatewayOption = false,
  onSuccess,
  onCash,
  onClose,
  onOnline,
}) {
  const normalizedStatus = normalizePaymentMode(status);
  const sqr = parseSqrPaymentResponse(processPaymentBody || {});
  const bodyStatus = normalizePaymentMode(processPaymentBody?.status);
  const isSuccessStatus =
    normalizedStatus === "SUCCESS" || bodyStatus === "SUCCESS";

  if (sqr.isSqrPayment) {
    const amountRs =
      paymentRequest?.amount != null ? paymentRequest.amount : undefined;

    if (isSuccessStatus) {
      return showSqrPaymentTransactionsFlow({
        transactions: sqr.transactions,
        pgId,
        amountRs,
        paymentRequest,
        onSuccess,
        onCash,
        onOnline,
      });
    }

    return showSqrPaymentFailPopup({ onCash, onOnline });
  }

  const handleRetry = paymentRequest
    ? () =>
        retryProcessPayment({
          paymentRequest,
          balancePayment,
          refund,
          showOnlineGatewayOption,
          onSuccess,
          onCash,
          onClose,
          onOnline,
        })
    : undefined;
  const handleClose =
    onClose ||
    (balancePayment === "Y"
      ? () => {
          clearAllPaymentFlowState();
        }
      : undefined);
  const canShowOnlineButton =
    refund !== "Y" && showOnlineGatewayOption && Boolean(onOnline);

  if (normalizedStatus === "INITIATED") {
    return showPaymentInitiatedPopup({
      pgId,
      gatewayTransactionId,
      balancePayment,
      refund,
      showOnlineButton: canShowOnlineButton,
      onSuccess,
      onCash,
      onOnline,
      onClose: handleClose,
    });
  }

  return showPaymentFailPopup({
    status: normalizedStatus || "UNKNOWN",
    message,
    onRetry: handleRetry,
    onCash,
    onClose: handleClose,
    showOnlineButton: canShowOnlineButton,
    onOnline,
  });
}

export async function handleProcessPaymentResponse({
  result,
  pgId,
  gatewayTransactionId,
  balancePayment,
  refund,
  invoiceId,
  paymentRequest,
  onSuccess,
  onCash,
  onClose,
}) {
  const session = {
    pgId,
    gatewayTransactionId,
    balancePayment: balancePayment || "N",
    refund: refund || "N",
    invoiceId,
    status: normalizePaymentMode(result?.status),
    message: result?.message,
    useNewPaymentFlow: true,
  };
  savePaymentSession(session);

  return runOnlinePaymentUi({
    status: session.status,
    message: session.message,
    pgId,
    gatewayTransactionId,
    balancePayment: session.balancePayment,
    refund: session.refund,
    paymentRequest,
    onSuccess,
    onCash,
    onClose,
  });
}
